<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiChevronDown } from "@mdi/js";
export default {
  name: "MdiChevronDown",
  data() {
    return {
      svgPath: mdiChevronDown,
    };
  },
};
</script>
